module.exports = __webpack_public_path__ + "img/white_paper6.771791a9.png";